function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import map from 'lodash/map';
import size from 'lodash/size';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import messages from 'modules/PatientResults/messages';
import { SEC_PER_WEEK } from 'modules/MobileReports/constants';
import { TimeSeriesResourcesHelper } from 'modules/PatientResults/helpers/TimeSeriesResourcesHelper';
import BloodGlucoseConcentrationChart from './BloodGlucoseConcentrationChart';
import Header from './Header';
import DailyChart from './DailyChart';
import Summary from './Header/Summary';
import { useChartsConfig, useWeeksData } from './hooks';
import Footer from './Footer';
import styles from './DailyLogReport.pcss';
const gridTheme = ()=>({
        grid: {
            stroke: '#E0E8F4',
            strokeWidth: 1
        }
    });
const DailyLogReport = ({ conversion, carbsConversion, standards, readings, relatedData, timeSeriesResources, phiSet, direction, accountPatientProfile, calculationFormula, startDate, endDate, customRanges })=>{
    useStyles(styles);
    const { customRangesLabels, ticks } = useChartsConfig(calculationFormula, customRanges);
    const groupedByWeek = useWeeksData(startDate, endDate, readings, relatedData, timeSeriesResources, standards, customRanges);
    if (!phiSet) return null;
    const timeSeriesResourcesHelper = new TimeSeriesResourcesHelper();
    const groupedArray = Array.from(groupedByWeek.entries());
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: map(groupedArray, ([weekNumber, weekData])=>{
            const { startDayTimestamp, readingsWithRelatedData, timeSeriesResources, statsData } = weekData;
            const revertedweekNumber = size(groupedByWeek) - +weekNumber;
            const translatedTimeSeriesResources = timeSeriesResourcesHelper.translateToDailyLogReportRelatedValues(timeSeriesResources) || {};
            return /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.printableDailyLogReport, 'page'),
                children: [
                    /*#__PURE__*/ _jsx(Header, {
                        phiSet: phiSet,
                        accountPatientProfile: accountPatientProfile,
                        standards: standards,
                        conversion: conversion
                    }),
                    /*#__PURE__*/ _jsx(Summary, {
                        phiSet: phiSet,
                        readingsWithRelatedData: readingsWithRelatedData,
                        translatedTimeSeriesResources: translatedTimeSeriesResources,
                        conversion: conversion,
                        standards: standards,
                        weekNumber: Number(revertedweekNumber),
                        startDayTimestamp: +startDayTimestamp
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.standardDay__wrapper,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: styles.standardDay,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.standardDay))
                            }),
                            /*#__PURE__*/ _jsx(BloodGlucoseConcentrationChart, {
                                conversion: conversion,
                                standards: standards,
                                readings: statsData.readings,
                                averageData: statsData.averageData,
                                start: +startDayTimestamp,
                                end: +startDayTimestamp + SEC_PER_WEEK,
                                timestampKey: "timestamp",
                                valueKey: "value",
                                direction: direction,
                                isLineEnabled: false,
                                isGridXEnabled: undefined,
                                isPlainValuesMode: false,
                                isReadOnly: true,
                                isCustomRanges: true,
                                ticks: ticks,
                                formatLabel: ()=>'',
                                enableGridY: false,
                                gridTheme: gridTheme,
                                customRangesLabels: customRangesLabels,
                                dailyChartHeight: 743
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(DailyChart, {
                        readingsWithRelatedData: readingsWithRelatedData,
                        conversion: conversion,
                        carbsConversion: carbsConversion,
                        standards: standards,
                        direction: direction,
                        ticks: ticks,
                        customRanges: customRanges,
                        translatedTimeSeriesResources: translatedTimeSeriesResources,
                        showDayDividers: true,
                        startDayTimestamp: startDayTimestamp
                    }),
                    /*#__PURE__*/ _jsx(Footer, {
                        currentPage: size(groupedByWeek) - +weekNumber,
                        numberOfPages: size(groupedByWeek)
                    })
                ]
            }, revertedweekNumber);
        })
    });
};
export default DailyLogReport;
